<app-navbar [navClass]="'defaultscroll is-sticky'" [navLight]="false"></app-navbar>

<section class="relative lg:pb-24 pb-16 md:mt-[84px] mt-[70px]">
    <div class="md:container container-fluid relative">
        <div class="relative overflow-hidden md:rounded-md shadow dark:shadow-gray-800 h-52 bg-[url('../../assets/images/bg/cta.jpg')] bg-center bg-no-repeat bg-cover"></div>
    </div>

    <div class="container relative md:mt-24 mt-16">
        <div class="md:flex">
            <div class="lg:w-1/4 md:w-1/3 md:px-3">
                <app-tab-account></app-tab-account>
            </div>

            <div class="lg:w-3/4 md:w-2/3 md:px-3 mt-6 md:mt-0">
                <div>
                    <h5 class="text-lg font-semibold mb-6">Introduction</h5>

                    <p class="text-slate-400 mt-4">Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus how to pursue pleasure rationally encounter but because those who do not know how to pursue consequences that are extremely</p>
                    <p class="text-slate-400 mt-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem earum dicta saepe fugit, qui commodi possimus vero pariatur asperiores. Sed impedit reprehenderit deserunt culpa incidunt iste laborum placeat molestiae illo?</p>
                </div>

                <div class="mt-6">
                    <h5 class="text-lg font-semibold mb-6">My Tours</h5>

                    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                        <div *ngFor="let item of package | slice : 0 : 6 " class="group rounded-md shadow dark:shadow-gray-700">
                            <app-grid-data [packageData]="item"></app-grid-data>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
<app-switcher></app-switcher>
